import {FC, PropsWithChildren, ReactElement} from "react";
import Button from '@mui/material/Button';
import Dialog, {DialogProps} from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import {useTheme} from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import {SlideTransition} from "./Dialog.tsx";

type ModalProps = PropsWithChildren<Omit<DialogProps, 'onClose'> & {
    onClose: () => void
    title: string
    actions?: ReactElement[]
    fullScreen?: boolean
    fullScreenOnMobile?: boolean
}>

const Modal: FC<ModalProps> = ({onClose, title, children, actions, fullScreen, fullScreenOnMobile, ...rest}) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    fullScreen = fullScreen || fullScreenOnMobile && isMobile;

    return (
        <Dialog
            {...rest}
            onClose={onClose}
            aria-labelledby="customized-dialog-title"
            maxWidth="xl"
            fullScreen={fullScreen}
            slots={{
                transition: SlideTransition,
            }}
            keepMounted
        >
            <DialogTitle sx={{m: 0, p: 2, font: "inherit"}} id="customized-dialog-title">
                {title}
            </DialogTitle>
            <IconButton
                aria-label="close"
                onClick={onClose}
                sx={(theme) => ({
                    position: 'absolute',
                    right: 8,
                    top: 8,
                    color: theme.palette.grey[500],
                })}
            >
                <CloseIcon/>
            </IconButton>
            <DialogContent sx={{ paddingLeft: 0, paddingRight: 0 }}>
                {children}
            </DialogContent>
            <DialogActions>
                {actions ?? (
                    <Button onClick={onClose}>
                        Sluiten
                    </Button>
                )}
            </DialogActions>
        </Dialog>
    )
}

export default Modal
